import { takeLatest, put, call } from 'redux-saga/effects';
import { EWS_API } from '../../../../../config';
import * as EwsReportListAction from './action';
import request from '../../../../../components/Utils/httpHelper';
const token = localStorage.getItem('id_token');
const httpHeaders = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json',
    'Authorization': `Bearer ${token}`
}



export function* getEwsReportDetailsList(action) {
    let requestUrl = `${EWS_API}/ews/corporate/summary?publishId=${action.data.publishId}&isPortfolio=${action.data.isPortfolio}`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'GET', data:'', headers: httpHeaders });
        yield put(EwsReportListAction.listEwsReportSuccess(createResult.data));
    } catch (err) {
        if (!err.response) {
            yield put(EwsReportListAction.listEwsReportFailure(false))
        } else {
            yield put(EwsReportListAction.listEwsReportFailure(err))
        }

    }
}

export function* getEwsReportList(action) {
    yield takeLatest(EwsReportListAction.LIST_EWSREPORT, getEwsReportDetailsList);
}